export default __webpack_public_path__ + "static/media/setting-option-outline-16px.31d84a89.svg";